





import Vue from 'vue'

interface HitCountComputed {
    count: number
    show: boolean
}

export default Vue.extend<{}, {}, HitCountComputed , {}>({
	name: 'CategoryFilter',
    computed: {
        count() {
            return this.$store.getters.total
        },
        show() {
            return this.$store.getters.hasFilters || (this.$store.getters.query !== '' && this.$store.getters.query !== '*')
        }
    }
})
